import React from 'react';
import Translation from '@s/Translation';
import { CheckoutModal } from '@v/checkout/components/CheckoutModal';
import Button from '@s/Button';
import Icon from '@showclix-shared/Icon';

export const ClearCartModal = ({ onClose, onClear, open, loading }) => {
  return (
    <CheckoutModal open={open} onClose={onClose} backdrop>
      <CheckoutModal.Header>
        <CheckoutModal.Title>
          <Icon icon="icon-warning" color="#686868" />
          <Translation>{'checkout__clear_reservation'}</Translation>
        </CheckoutModal.Title>
        <CheckoutModal.CloseButton disabled={loading} />
      </CheckoutModal.Header>
      <CheckoutModal.Body>
        <div className="message__text message__text--align-left">
          <Translation>{'checkout__clear_reservation_description'}</Translation>
        </div>
      </CheckoutModal.Body>
      <CheckoutModal.Footer>
        <Button onClick={onClose} disabled={loading} className="button--secondary button--full button--medium">
          <Translation>{'checkout__cancel'}</Translation>
        </Button>
        <Button onClick={onClear} loading={loading} className="button--primary button--full button--medium">
          <Translation>{'checkout__clear_reservation'}</Translation>
        </Button>
      </CheckoutModal.Footer>
    </CheckoutModal>
  );
};
